import Footer from '../footer/Footer';
import Navbar from '../navbar/Navbar';
import FacilitiesLeftTab from './FacilitiesLeftTab';


const InfrastructureSports = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <FacilitiesLeftTab />
                        </div>

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>Infrastructure Sports
                                </h2>

                                <h6 className='pt-4 pb-3'>Infrastructure Sports Facility Images
                                </h6>

                                <div className='pt-4 row'>
                                    <div className="row">
                                        <div className="col-md-6 pb-3">
                                            <img
                                                src="https://admin.swec.ac.in/assetsswec/img/sports/Sports_Ground.jpeg"
                                                loading="lazy"
                                                className="img-fluid sixteen-nine rounded-1"
                                                alt="Sports Ground"
                                            />
                                        </div>
                                        <div className="col-md-6 pb-3">
                                            <img
                                                src="https://admin.swec.ac.in/assetsswec/img/sports/SWEC-Sports-Winners.jpg"
                                                loading="lazy"
                                                className="img-fluid sixteen-nine rounded-1"
                                                alt="SWEC Sports Winners"
                                            />
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default InfrastructureSports
